import { useContext } from "react";
import { ShowContext } from "../../context/Context";
import {
  filteredObjects,
  getObservationMap,
  isKeyPresentInData,
} from "../service/constants";
import SideObservationMenu from "../sideObservationMenu/SideObservationMenu";
import SideObservationGraph from "../sideobservationgraph/SideObservationGraph";
import "./numericObservation.css";
import { useState } from "react";
const NumericObservation = () => {
  const { wholeData } = useContext(ShowContext);
  const isObservationPresent = isKeyPresentInData("Observation", wholeData);
  const [selectedObservation, setSelectedObservation] = useState(null);

  const insideObjects = wholeData?.find(
    (item) => item.resourceType === "Observation"
  );

  if (!insideObjects?.objects) {
    return <h1>No Observation Data</h1>;
  }

  const reqObservation = getObservationMap(insideObjects.objects);
  const mappedObservations = Array.from(reqObservation).map(([key, value]) => {
    return {
      observationType: key,
      objects: value,
    };
  });

  const observationsWithValueQuantity = filteredObjects(mappedObservations);

  if (!isObservationPresent || observationsWithValueQuantity.length === 0) {
    return <h1>No Observation Data</h1>;
  }

  return (
    <div className="observationContainer">
      <SideObservationMenu
        observations={observationsWithValueQuantity}
        selectedObservation={selectedObservation}
        setSelectedObservation={setSelectedObservation}
      />
      {selectedObservation && (
        <SideObservationGraph
          selectedObservation={selectedObservation}
          mappedObservations={mappedObservations}
        />
      )}
    </div>
  );
};

export default NumericObservation;
